import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioPreguntaRespuesta } from '../../_models/cuestionario-pregunta-respuesta';
import { forkJoin } from 'rxjs';
import { CuestionarioPreguntaRespuestaService } from '../../_services/cuestionario-pregunta-respuesta.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { RetornoFuncionalidades } from '../../_models/retorno-funcionalidades';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuVisitaService } from '../../_services/menu-visita.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { MenuVisita } from '../../_models/menu-visita';
import { MenuVisitaVinculacionService } from '../../_services/menu-visita-vinculacion.service';
import { MenuVisitaVinculacion } from '../../_models/menu-visita-vinculacion';
import { MenuVisitaVinculacionOcupacionService } from '../../_services/menu-visita-vinculacion-ocupacion.service';
import { MenuVisitaVinculacionOcupacion } from '../../_models/menu-visita-vinculacion-ocupacion';

@Component( {
  selector: 'app-vinculacion-tercero-ocupacion',
  templateUrl: 'vinculacion-tercero-ocupacion.component.html'
} )

export class VinculacionTerceroOcupacionComponent implements OnInit {

  columnas: any[];
  carInformacionInicial = true;
  menu: Funcionalidad = new Funcionalidad();
  carTabla = false;
  formulario: FormGroup;
  menuVinculacion: MenuVisitaVinculacion;
  submitted = false;

  /** Listas */
  lisMenuOcupacion: MenuVisitaVinculacionOcupacion[] = [];
  lisTipoOcupacionesTodos: ListaItem[] = [];
  lisTipoOcupaciones: SelectItem[] = [];

  constructor( private navServicio: NavService,
               private cuePreguntaService: CuestionarioPreguntaService,
               private cuePreguntaRespuestaServicio: CuestionarioPreguntaRespuestaService,
               private cueServicio: CuestionarioService,
               private router: Router,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private serMenu: MenuVisitaService,
               private serLista: ListaService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private serMenuVinculacion: MenuVisitaVinculacionService,
               private serMenuOcupacion: MenuVisitaVinculacionOcupacionService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/preguntas' );
        if ( mn ) {
          this.menu = mn;
        }
        this.columnas = [
          { field: 'tipoOcupacion', header: this.navServicio.buscarMensaje( 'VINCULACIONTERCERO.LBL_TIPOOCUPACION' ), sort: false },
          { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
        ];
        this.carTabla = true;


        forkJoin( this.serMenuVinculacion.obtenerPorId( params[ 'id' ] ),
          this.serMenuOcupacion.listadoPorMenuVisitaVinculacion( params[ 'id' ] ),
          this.serLista.getMasterDetails( 'ListasTiposOcupaciones' ) ).subscribe( ( [ menuVinculacion, menuOcupacion, tipoOcupaciones ] ) => {

          this.menuVinculacion = menuVinculacion;
          this.lisMenuOcupacion = menuOcupacion;
          this.lisTipoOcupacionesTodos = tipoOcupaciones;

          this.lisTipoOcupacionesTodos.map( ( s: ListaItem ) => {
            if ( !this.lisMenuOcupacion.find( x => x.idTipoOcupacion === s.idLista && x.indicadorHabilitado ) ) {
              this.lisTipoOcupaciones.push( { label: s.nombre, value: s.idLista } );
            }
          } );

          this.cargarFormulario();
          this.carTabla = false;
          this.carInformacionInicial = false;

        } );
      }
    } );

  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idMenuVisitaVinOcupacion: [ null ],
      idTipoOcupacion: [ null, [ Validators.required ] ],
      idMenuVisitaVinculacion: [ this.menuVinculacion ? this.menuVinculacion.idMenuVisitaVinculacion : null, [ Validators.required ] ],
      indicadorHabilitado: [ true, [ Validators.required ] ],
    } );
  }


  onSubmit() {
    this.submitted = true;
    this.carTabla = true;
    if ( this.formulario.valid ) {
      const formulario = this.formulario.getRawValue();
      if ( this.lisMenuOcupacion.find( x => x.idTipoOcupacion === formulario.idTipoOcupacion && !x.indicadorHabilitado ) ) {
        this.lisMenuOcupacion.map( ( s: MenuVisitaVinculacionOcupacion ) => {
          if ( s.idTipoOcupacion === formulario.idTipoOcupacion ) {
            s.indicadorHabilitado = true;
            this.serMenuOcupacion.actualizar( s ).subscribe( regActualizado => {
              this.recargarTipoOcupaciones();
              this.carTabla = false;
              this.submitted = false;

              this.verificarIndicadorTodos();
            } );
          }
        } );

      } else {
        this.serMenuOcupacion.crear( formulario ).subscribe( meVinculacion => {
          this.lisMenuOcupacion = [];
          this.serMenuOcupacion.listadoPorMenuVisitaVinculacion( this.menuVinculacion.idMenuVisitaVinculacion ).subscribe( menuOcupacion => {
            this.lisMenuOcupacion = menuOcupacion;
            this.recargarTipoOcupaciones();
            this.carTabla = false;
            this.submitted = false;

            this.verificarIndicadorTodos();
          } );
        } );
      }

    }
  }

  verificarIndicadorTodos() {
    if ( this.menuVinculacion.indicadorTodos && this.lisMenuOcupacion.filter( x => x.indicadorHabilitado ).length > 0 ) {
      this.menuVinculacion.indicadorTodos = false;
      this.actualizarMenuVinculacion();
      this.recargarTipoOcupaciones();
    } else if ( !this.menuVinculacion.indicadorTodos && this.lisMenuOcupacion.filter( x => x.indicadorHabilitado ).length === this.lisTipoOcupacionesTodos.length ) {
      this.menuVinculacion.indicadorTodos = true;
      this.actualizarMenuVinculacion();
      this.recargarTipoOcupaciones();
    }
  }

  recargarTipoOcupaciones() {
    this.lisTipoOcupaciones = [];
    this.lisTipoOcupacionesTodos.map( ( s: ListaItem ) => {
      if ( !this.lisMenuOcupacion.find( x => x.idTipoOcupacion === s.idLista && x.indicadorHabilitado ) ) {
        this.lisTipoOcupaciones.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  eliminar( row: any ) {
    this.carTabla = true;
    this.lisMenuOcupacion.map( s => {
      if ( s.idMenuVisitaVinOcupacion === row.idMenuVisitaVinOcupacion ) {
        s.indicadorHabilitado = false;
        this.serMenuOcupacion.actualizar( s ).subscribe( regActualizado => {
          this.recargarTipoOcupaciones();
          this.carTabla = false;


          if ( !this.menuVinculacion.indicadorTodos && this.lisMenuOcupacion.filter( x => x.indicadorHabilitado ).length === 0 ) {
            this.menuVinculacion.indicadorTodos = true;
            this.actualizarMenuVinculacion();
          } else if ( this.menuVinculacion.indicadorTodos && this.lisMenuOcupacion.filter( x => x.indicadorHabilitado ).length > 0 ) {
            this.menuVinculacion.indicadorTodos = false;
            this.actualizarMenuVinculacion();
          }
        } );
      }
    } );

  }

  actualizarMenuVinculacion() {
    this.serMenuVinculacion.actualizar( this.menuVinculacion ).subscribe( regActualizado => {
    } );
  }

  listarHabilitados() {
    return this.lisMenuOcupacion.filter( x => x.indicadorHabilitado );
  }

  get f() {
    return this.formulario.controls;
  }

  regresar() {
    this.router.navigate( [ 'apl/vinculacion-tercero/configurar-vinculacion/' + this.menuVinculacion.idTipoVinculacion ] );
  }
}
